const MY_DOCTOR_DISPLAY_SIZE = 5;
export default MY_DOCTOR_DISPLAY_SIZE;
